import React, { Component } from 'react';
import { strings } from '../../../../localization';

import GuestUserAccessPage from './GuestUserAccessPage';
import OwnerUserAccessPage from './OwnerUserAccessPage';


/**
 * Shows an error if we can't load the selectedRaven or delegates to OwnerUserAccessPage or
 * GuestUserAccessPage depending on the current user's accessLevel
 **/
export default class MobileUsersPage extends Component {
    render() {
        const { selectedRaven, user } = this.props;

        if (!selectedRaven) return <NoRavenSelectedError />;

        if (selectedRaven.canEdit) {
            return <OwnerUserAccessPage {...this.props}/>;
        } else {
            return <GuestUserAccessPage raven={selectedRaven} user={user} />;
        }
    }
}

const NoRavenSelectedError = () => (
    <div className="page-error">
        <h2>{strings.formatString(strings.app_oops)}</h2>
        <hr />
        <p>{strings.formatString(strings.mo_ravens_error)}</p>
    </div>
);
